import * as types from "../services/changePasswordActionType";

const initialState = {
  isChangePasswordLoading: false,
  isChangePasswordSuccess: false,
};

const changePasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_PASSWORD_REQUEST:
      return { ...state, isChangePasswordLoading: true, isChangePasswordSuccess: false };
    case types.CHANGE_PASSWORD_SUCCESS:
      return { ...state, isChangePasswordLoading: false, isChangePasswordSuccess: true };
    case types.CHANGE_PASSWORD_FAILURE:
      return { ...state, isChangePasswordLoading: false, isChangePasswordSuccess: false };
    default:
      return state;
  }
};

export default changePasswordReducer;
